import type { ReactNode } from 'react';

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        isCenter ? 'md:flex-col md:items-center text-center' : 'md:justify-between'
      }`}
    >
      <div className={isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <div
            className={`flex items-center gap-2 text-sm font-medium text-primary-600 ${
              isCenter ? 'justify-center' : ''
            }`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            {eyebrow}
          </div>
        )}
        <h2 className="mt-3 text-2xl text-foreground-950 md:text-4xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}